import { observer } from 'mobx-react-lite';
import React from 'react';

import { classes } from '~utils/ClassNames';
import { diContainer } from '~setup/diContainer';
import { serviceNames } from '~setup/CartService';
import { ICartRepository } from '~repositories/CartRepository/ICartRepository';
import { ViewWrapper, LineItem, LineItemSubText } from './DiscountViewStyles';
import { DiscountDetailsView } from './DiscountDetailsView';
import { useTranslation } from '~sharedComponents/Providers/Translations/TranslationsHook';
import TextLabel from '~sharedComponents/TextLabel/TextLabel';
import { getFormattedPrice } from '~utils/FormattedPrice';

const translations = ['subtotal', 'discounts'];
const discountViewClass = classes('tax-shipping');
const discountViewContentClass = 'elc-tax-shipping-content';
const discountViewContentLabelClass = 'elc-tax-shipping-content-label';
const discountViewContentValueClass = 'elc-tax-shipping-content-value';
const summaryDiscountClass = classes('summary-discount');

export const DiscountView = observer(() => {
    const cartRepository: ICartRepository = diContainer.get(serviceNames.cartRepository);

    const {
        discountAmount,
        formattedDiscountAmount,
        totalPrice,
        formattedTotalPrice,
        isDiscounted,
        subtotalWithoutDonation,
        offersSummary
    } = cartRepository.cart.cartTotals.discount || {};

    const { subtotal, discounts } = useTranslation(translations);

    const cartTotal = getFormattedPrice({
        price: subtotalWithoutDonation || totalPrice,
        fallback: formattedTotalPrice
    });
    const cartDiscount = getFormattedPrice({
        price: discountAmount,
        fallback: formattedDiscountAmount
    });

    return (
        <ViewWrapper className={discountViewClass}>
            <LineItem className={discountViewContentClass}>
                <LineItemSubText className={discountViewContentLabelClass}>
                    {subtotal}
                </LineItemSubText>
                <LineItemSubText className={discountViewContentValueClass}>
                    <TextLabel text={cartTotal} />
                </LineItemSubText>
            </LineItem>

            {!!isDiscounted && (
                <>
                    <LineItem className={summaryDiscountClass}>
                        <LineItemSubText className={discountViewContentLabelClass}>
                            {discounts}
                        </LineItemSubText>
                        <LineItemSubText className={discountViewContentValueClass}>
                            <TextLabel text={cartDiscount} />
                        </LineItemSubText>
                        {offersSummary && <DiscountDetailsView offers={offersSummary} />}
                    </LineItem>
                </>
            )}
        </ViewWrapper>
    );
});
